/* recent houses
 ==================================================================================================== */
(function() {
    $(document).on('click', '#show-more-houses', function(event){
        event.preventDefault();
        $(this).parent().find('li').each(function(index){
            $(this).slideDown();
        });
        $(this).hide();
    });
})();